import { render, staticRenderFns } from "./GroupLinksInfo.vue?vue&type=template&id=547c4204&scoped=true&lang=pug"
import script from "./GroupLinksInfo.vue?vue&type=script&lang=js"
export * from "./GroupLinksInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupLinksInfo.vue?vue&type=style&index=0&id=547c4204&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547c4204",
  null
  
)

export default component.exports